module.exports = __webpack_public_path__ + "media/img/features/languages-large-0006431dffc123ad214c8b29518e736b.png";